import { withRouter } from 'react-router-dom';
import { FileConverter } from './FileConverter';

const PostmanConverter = () => (<FileConverter type = {'postman'} />)

export default withRouter(PostmanConverter);
